export default "__VITE_ASSET__DRIPDzS6__"